import { Component } from '@angular/core';

@Component({
  selector: 'spe-step-content',
  imports: [],
  templateUrl: './step-content.component.html',
  styleUrl: './step-content.component.scss'
})
export class StepContentComponent {

}
